import PropTypes from 'prop-types';

const topicAttributeShape = {
  name: PropTypes.string.isRequired,
};

export default topicAttributeShape;
